import React from 'react'
import Icon from './Icon'

function HomeIcon(props) {
  return <Icon solid label="home" {...props} />
}

export default HomeIcon;
